import {useMutation} from "@tanstack/react-query";

import {removeRepresentativeCommissionMutationOptions} from "./remove-representative-commission.mutation-options";

export function useRemoveRepresentativeCommission(representativeId: string) {
  return useMutation(removeRepresentativeCommissionMutationOptions(representativeId));
}
